module.exports = __webpack_public_path__ + "static/media/990827.81ff19dd.png";